import { ModalComponent } from '../../../../config/core.modal-helpers';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';


@Component({
	selector: 'project-sprint-add',
	template: require('./project.sprint.add.html'),
})
export class ProjectSprintAddModalComponent extends ModalComponent {

	@Input() sprint: any = null;
	@Input() project: any = null;

	@Input() legacyCallback: any = null;

	@Output() callback = new EventEmitter<any>();

	constructor(
		private projectService: ProjectService,
		private uiService: UiService,
		private gfTranslateService: GfTranslateService,
	) {
		super();
	}

	addSprint = () => {
		var ret = false;

		this.projectService.updateSprint(
			this.sprint
		).then(() => {
			this.uiService.message.showSuccess(
				this.gfTranslateService.translate('The sprint has been succesfuly added.'), 'Sprint added');
			ret = true;
		}).catch(() => {
			var msg = this.gfTranslateService.translate('There was a problem adding the sprint');
			this.uiService.message.showWarning(msg, 'Data Error');
		}).finally(() => {
			this.legacyCallback && this.legacyCallback(this.sprint, ret);
			this.callback.emit(this.sprint);
			this.closeModal(ret);
		});
	};

	defaultEndDate = ($event) => {
		this.sprint.sprintStart = $event;

		// Update the end date if it's BEFORE the new start date
		const newDate = new Date(Date.parse($event));
		const newString = newDate.toISOString().substring(0, 10);

		if ((!this.sprint.sprintEnd) ||
			(newString > this.sprint.sprintEnd)) {
			newDate.setDate(newDate.getDate() + 13);
			this.sprint.sprintEnd = newDate.toISOString().substring(0, 10);
		}
	};

	onEndDateUpdate = ($event) => {
		this.sprint.sprintEnd = $event;
	}
}